function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var ImageHash = /*#__PURE__*/function () {
  /**
   * @param binArray {Uint8ClampedArray}
   */
  function ImageHash(binArray) {
    _classCallCheck(this, ImageHash);
    _defineProperty(this, "binArray", void 0);
    this.binArray = binArray;
  }
  return _createClass(ImageHash, [{
    key: "toHexStringReversed",
    value: function toHexStringReversed() {
      var str = "";
      for (var i = 0; i < this.binArray.length; i += 8) {
        var c = this.binArray[i] << 7 | this.binArray[i + 1] << 6 | this.binArray[i + 2] << 5 | this.binArray[i + 3] << 4 | this.binArray[i + 4] << 3 | this.binArray[i + 5] << 2 | this.binArray[i + 6] << 1 | this.binArray[i + 7];
        str += c.toString(16).padStart(2, "0");
      }
      return str;
    }
  }, {
    key: "toHexString",
    value: function toHexString() {
      var str = "";
      for (var i = 0; i < this.binArray.length; i += 8) {
        var c = this.binArray[i] | this.binArray[i + 1] << 1 | this.binArray[i + 2] << 2 | this.binArray[i + 3] << 3 | this.binArray[i + 4] << 4 | this.binArray[i + 5] << 5 | this.binArray[i + 6] << 6 | this.binArray[i + 7] << 7;
        str += c.toString(16).padStart(2, "0");
      }
      return str;
    }
  }, {
    key: "toBase64",
    value: function toBase64() {
      var buf = [];
      for (var i = 0; i < this.binArray.length; i += 8) {
        buf.push(this.binArray[i] | this.binArray[i + 1] << 1 | this.binArray[i + 2] << 2 | this.binArray[i + 3] << 3 | this.binArray[i + 4] << 4 | this.binArray[i + 5] << 5 | this.binArray[i + 6] << 6 | this.binArray[i + 7] << 7);
      }
      return btoa(String.fromCharCode.apply(String, _toConsumableArray(new Uint8Array(buf))));
    }

    /**
     * @param hash {ImageHash}
     * @returns number
     */
  }, {
    key: "hammingDistance",
    value: function hammingDistance(hash) {
      if (hash.binArray.length !== this.binArray.length) {
        throw new Error("Cannot compare two ImageHash instances of different sizes");
      }
      var distance = 0;
      for (var i = 0; i < this.binArray.length; i++) {
        if (this.binArray[i] !== hash.binArray[i]) {
          distance += 1;
        }
      }
      return distance;
    }
  }], [{
    key: "fromBase64",
    value: function fromBase64(s) {
      var buf = atob(s);
      var arr = new Uint8ClampedArray(buf.length * 8);
      for (var i = 0; i < buf.length; i++) {
        var c = buf.charCodeAt(i);
        arr[i * 8] = c & 0x01;
        arr[i * 8 + 1] = (c & 0x02) >> 1;
        arr[i * 8 + 2] = (c & 0x04) >> 2;
        arr[i * 8 + 3] = (c & 0x08) >> 3;
        arr[i * 8 + 4] = (c & 0x10) >> 4;
        arr[i * 8 + 5] = (c & 0x20) >> 5;
        arr[i * 8 + 6] = (c & 0x40) >> 6;
        arr[i * 8 + 7] = (c & 0x80) >> 7;
      }
      return new ImageHash(arr);
    }
  }, {
    key: "fromHexStringReversed",
    value: function fromHexStringReversed(s) {
      if (s.length % 2 !== 0) {
        throw Error("hex string length must be a multiple of 2");
      }
      var arr = new Uint8ClampedArray(s.length * 4);
      for (var i = 0; i < s.length; i += 2) {
        var c = Number.parseInt(s.slice(i, i + 2), 16);
        if (Number.isNaN(c)) {
          throw Error("Invalid hex string");
        }
        arr[i * 4] = (c & 0x80) >> 7;
        arr[i * 4 + 1] = (c & 0x40) >> 6;
        arr[i * 4 + 2] = (c & 0x20) >> 5;
        arr[i * 4 + 3] = (c & 0x10) >> 4;
        arr[i * 4 + 4] = (c & 0x08) >> 3;
        arr[i * 4 + 5] = (c & 0x04) >> 2;
        arr[i * 4 + 6] = (c & 0x02) >> 1;
        arr[i * 4 + 7] = c & 0x01;
      }
      return new ImageHash(arr);
    }
  }, {
    key: "fromHexString",
    value: function fromHexString(s) {
      if (s.length % 2 !== 0) {
        throw Error("hex string length must be a multiple of 2");
      }
      var arr = new Uint8ClampedArray(s.length * 4);
      for (var i = 0; i < s.length; i += 2) {
        var c = Number.parseInt(s.slice(i, i + 2), 16);
        if (Number.isNaN(c)) {
          throw Error("Invalid hex string");
        }
        arr[i * 4] = c & 0x01;
        arr[i * 4 + 1] = (c & 0x02) >> 1;
        arr[i * 4 + 2] = (c & 0x04) >> 2;
        arr[i * 4 + 3] = (c & 0x08) >> 3;
        arr[i * 4 + 4] = (c & 0x10) >> 4;
        arr[i * 4 + 5] = (c & 0x20) >> 5;
        arr[i * 4 + 6] = (c & 0x40) >> 6;
        arr[i * 4 + 7] = (c & 0x80) >> 7;
      }
      return new ImageHash(arr);
    }
  }]);
}();
export var ImageMultiHash = /*#__PURE__*/function () {
  function ImageMultiHash(hashes) {
    _classCallCheck(this, ImageMultiHash);
    this.segmentHashes = hashes;
  }
  return _createClass(ImageMultiHash, [{
    key: "toJSON",
    value: function toJSON() {
      return this.segmentHashes.map(function (h) {
        return h.toHexString();
      });
    }
  }, {
    key: "hashDiff",
    value:
    /**
     * @param hash {ImageMultiHash}
     * @param hammingCutoff {number}
     * @return {sum: number, num: number}
     */
    function hashDiff(hash, hammingCutoff) {
      var sum = 0;
      var num = 0;
      for (var i = 0; i < hash.segmentHashes.length; i++) {
        var distances = [];
        for (var j = 0; j < this.segmentHashes.length; j++) {
          distances.push(hash.segmentHashes[i].hammingDistance(this.segmentHashes[j]));
        }
        var minDistance = Math.min.apply(Math, distances);
        if (minDistance <= hammingCutoff) {
          sum += minDistance;
          num += 1;
        }
      }
      return {
        num: num,
        sum: sum
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      return new ImageMultiHash(json.map(function (s) {
        return ImageHash.fromHexString(s);
      }));
    }
  }]);
}();